import React, { useState } from "react";
import API from "../../services/api.ts";
import { toast } from "react-toastify";

const StudyForm = ({ projectId, study, onClose, onSuccess }) => {
    const [formData, setFormData] = useState({
        name: study?.name || "",
        description: study?.description || "",
        status: study?.status || "draft",
        share_annotations: study?.share_annotations || false,
    });
    const [loading, setLoading] = useState(false);

    const isEditing = !!study;

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.name.trim()) {
            toast.error("Study name is required.");
            return;
        }

        setLoading(true);
        try {
            const payload = {
                ...formData,
                project: projectId,
            };

            if (isEditing) {
                await API.patch(`/studies/${study.id}/`, payload);
                toast.success("Study updated successfully!");
            } else {
                await API.post("/studies/", payload);
                toast.success("Study created successfully!");
            }
            onSuccess();
        } catch (err) {
            console.error("Error saving study:", err);
            const message = err.response?.data?.project?.[0] ||
                          err.response?.data?.detail ||
                          "Failed to save study.";
            toast.error(message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modal show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">
                            {isEditing ? "Edit Study" : "Create New Study"}
                        </h5>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={onClose}
                            disabled={loading}
                        ></button>
                    </div>
                    <form onSubmit={handleSubmit}>
                        <div className="modal-body">
                            <div className="mb-3">
                                <label className="form-label">Study Name *</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    placeholder="Enter study name"
                                    required
                                />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Description</label>
                                <textarea
                                    className="form-control"
                                    name="description"
                                    value={formData.description}
                                    onChange={handleChange}
                                    placeholder="Enter study description"
                                    rows="3"
                                />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Status</label>
                                <select
                                    className="form-select"
                                    name="status"
                                    value={formData.status}
                                    onChange={handleChange}
                                >
                                    <option value="draft">Draft</option>
                                    <option value="active">Active</option>
                                    <option value="completed">Completed</option>
                                    <option value="archived">Archived</option>
                                </select>
                            </div>
                            <div className="mb-3">
                                <div className="form-check">
                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="share_annotations"
                                        name="share_annotations"
                                        checked={formData.share_annotations}
                                        onChange={handleChange}
                                    />
                                    <label className="form-check-label" htmlFor="share_annotations">
                                        <strong>Share annotations between annotators</strong>
                                    </label>
                                </div>
                                <small className="text-muted d-block mt-1">
                                    When enabled, all team members can see each other's annotations with attribution,
                                    and can add their own annotations to the same data.
                                </small>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={onClose}
                                disabled={loading}
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={loading}
                            >
                                {loading ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2"></span>
                                        {isEditing ? "Updating..." : "Creating..."}
                                    </>
                                ) : (
                                    isEditing ? "Update Study" : "Create Study"
                                )}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default StudyForm;
